import { combineReducers } from 'redux';
import { GET_EXPERIENCE, GET_ABOUT_ME, GET_EDUCATION, GET_SKILLS } from './actions';

function aboutReducer(state = {}, action) {
  switch (action.type) {
    case GET_ABOUT_ME:
      state = action.payload;
      return state;
    default:
      return state;
  }
}

function experienceReducer(state = [], action) {
  switch (action.type) {
    case GET_EXPERIENCE:
      state = action.payload;
      return state;
    default:
      return state;
  }
}

function educationReducer(state = [], action) {
  switch (action.type) {
    case GET_EDUCATION:
      state = action.payload;
      return state;
    default:
      return state;
  }
}

function skillsReducer(state = [], action) {
  switch (action.type) {
    case GET_SKILLS:
      state = action.payload;
      return state;
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  aboutMe: aboutReducer,
  experience: experienceReducer,
  education: educationReducer,
  skills: skillsReducer,
});
export default rootReducer;
